var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Checkbox, FormControl, FormControlLabel, FormGroup, Grid, IconButton, styled, TextField, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { UploadImage } from "../../../api/api";
import { getUploadAttachmentForTranslateToJobItemUrl, translateToJobDeleteAttachement } from "../../../api/url";
import { DeleteButtonNewIcon } from "../../../assets/images";
import { showLoader } from "../../../redux/commonSlice";
import { getListAPI } from "../../../redux/crudSlice";
import { useAppDispatch } from "../../../store/hooks";
import { MuiBox } from "../../atoms/boxComponent";
import { MuiImagePopUp } from "../../atoms/imageDialogBox";
import SkeletonLoader from "../../atoms/sketeton";
import { MuiStack } from "../../atoms/stackComponent";
import ViewAllImagePopUp from "../../atoms/viewAllImagePopUp";
import { AudioPlayer } from "../../molecules/audioComponent";
import { AudioComponent } from "./audioRecorder";
import ImageCapture from "./imageCapture";
import { GalleryIcon } from "../../../assets/customIcons";
import { systemColor } from "../../../theme/systemColor";
import { FreeTextMaxLength } from "../../../constants";
var Box = styled(MuiBox)(function (_ref) {
    var theme = _ref.theme;
    return {
        //margin: 10,
        padding: 2,
        borderRadius: "12px",
        backgroundColor: "#F4F7FA"
    };
});
export var CheckBoxComponent = function (props) {
    var itemsList = props.itemsList, onChange = props.onChange, groupItem = props.groupItem, searchValue = props.searchValue, isDisabled = props.isDisabled, isSkeletonVisible = props.isSkeletonVisible, filterSystemName = props.filterSystemName, ComplaintGroupId = props.ComplaintGroupId, searchedItems = props.searchedItems;
    var _a = useState(itemsList), jobItemList = _a[0], setJobItemList = _a[1];
    var dispatch = useAppDispatch();
    var _b = useParams(), id = _b.id, vehicleInspectionId = _b.vehicleInspectionId;
    var _c = useState(false), isDrawerOpen = _c[0], setISDrawerOpen = _c[1];
    var _d = useState(""), imageURL = _d[0], setImageURL = _d[1];
    var fileInputRef = useRef(null);
    useEffect(function () {
        setJobItemList(itemsList);
    }, [itemsList]);
    var uploadAttachment = function (image, jobItemId) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    formData = new FormData();
                    formData.append('data', image);
                    return [4 /*yield*/, UploadImage(getUploadAttachmentForTranslateToJobItemUrl(jobItemId), formData, 'BlankSystemName', dispatch)];
                case 1:
                    result = _a.sent();
                    if (result.success) {
                        return [2 /*return*/, result.attachmentId];
                    }
                    else {
                        return [2 /*return*/, ""];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error uploading image:", error_1);
                    return [2 /*return*/, ""];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (event, items) {
        var _jobItem = __spreadArray([], jobItemList, true);
        var checkBoxSelection = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
            isCheckBoxClicked: !item.isCheckBoxClicked,
            Comments: !item.isCheckBoxClicked ? item.Comments : '',
            SystemName: filterSystemName,
            audioUrl: !item.isCheckBoxClicked ? item.audioUrl : "",
            audioDuration: !item.isCheckBoxClicked ? item.audioDuration : "",
            audioAttachmentId: !item.isCheckBoxClicked ? item.audioAttachmentId : "",
            images: !item.isCheckBoxClicked ? items.images : [],
            ComplaintGroupId: ComplaintGroupId
        }) : item; });
        setJobItemList(checkBoxSelection);
        onChange(checkBoxSelection, groupItem);
    };
    var handleTextInputChange = function (event, items) {
        var _jobItem = __spreadArray([], jobItemList, true);
        var dialogOpenConfirmation = _jobItem.map(function (item) {
            var _event$target$value;
            return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
                Comments: (_event$target$value = event.target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.trimStart(),
                SystemName: filterSystemName
            }) : item;
        });
        setJobItemList(dialogOpenConfirmation);
        onChange(dialogOpenConfirmation, groupItem);
    };
    var handleAudioUrl = function (blobUrl, duration, convertedBlob, items) {
        uploadAudio(blobUrl, duration, convertedBlob, items);
    };
    var uploadAudio = function (blobUrl, duration, convertedBlob, items) { return __awaiter(void 0, void 0, void 0, function () {
        var convertedBlobUrl;
        return __generator(this, function (_a) {
            convertedBlobUrl = URL.createObjectURL(convertedBlob);
            fetch(convertedBlobUrl).then(function (response) { return response.blob(); }).then(function (blob) { return __awaiter(void 0, void 0, void 0, function () {
                var mp3File, audioAttachmentId, _jobItem, urlconfirmation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            mp3File = new File([blob], "audio-".concat(new Date().toISOString(), ".mp3"), {
                                type: 'audio/mpeg'
                            });
                            return [4 /*yield*/, uploadAttachment(mp3File, items.ComplaintId)];
                        case 1:
                            audioAttachmentId = _a.sent();
                            _jobItem = __spreadArray([], jobItemList, true);
                            urlconfirmation = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
                                audioUrl: blobUrl,
                                audioDuration: duration,
                                audioAttachmentId: audioAttachmentId,
                                SystemName: filterSystemName,
                                isNewAudioUploaded: true
                            }) : item; });
                            setJobItemList(urlconfirmation);
                            onChange(urlconfirmation, groupItem);
                            return [2 /*return*/];
                    }
                });
            }); }).catch(function (error) { return console.error('Error fetching Blob:', error); });
            return [2 /*return*/];
        });
    }); };
    var handleImageList = function (imagesList, removedImageList, items) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedImagesList, _loop_1, _i, _a, listItem, successfullyUploadedImages, uploadPromises, deletePromise, uniqueAttachmentIds, newArray, _jobItem, urlconfirmation;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updatedImagesList = [];
                    if (items.images) {
                        _loop_1 = function (listItem) {
                            var temp = removedImageList.find(function (finalImageItem) { return finalImageItem.attachmentId === listItem.attachmentId; });
                            if (!temp) {
                                updatedImagesList.push(listItem);
                            }
                        };
                        for (_i = 0, _a = items.images; _i < _a.length; _i++) {
                            listItem = _a[_i];
                            _loop_1(listItem);
                        }
                    }
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    successfullyUploadedImages = [];
                    uploadPromises = imagesList.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var attachmentId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(!imageItem.attachmentId && !imageItem.isAlreadyUploaded)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachment(imageItem.file, items.ComplaintId)];
                                case 1:
                                    attachmentId = _a.sent();
                                    if (attachmentId) {
                                        successfullyUploadedImages.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                            attachmentId: attachmentId,
                                            isNewImageUploaded: true
                                        }));
                                    }
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 1:
                    _b.sent();
                    deletePromise = removedImageList.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var request, DeleteAttchementResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.isAlreadyUploaded) return [3 /*break*/, 2];
                                    request = {
                                        "SystemName": "Complaint",
                                        ParentId: items.ComplaintId,
                                        AttachmentId: imageItem.attachmentId,
                                        PreJobCardDocumentId: id !== null && id !== void 0 ? id : vehicleInspectionId
                                    };
                                    return [4 /*yield*/, dispatch(getListAPI({
                                            key: "",
                                            url: translateToJobDeleteAttachement,
                                            request: request
                                        }))];
                                case 1:
                                    DeleteAttchementResponse = _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(deletePromise)];
                case 2:
                    _b.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    updatedImagesList = __spreadArray(__spreadArray([], updatedImagesList, true), successfullyUploadedImages, true);
                    uniqueAttachmentIds = {};
                    updatedImagesList.forEach(function (item) {
                        uniqueAttachmentIds[item.attachmentId] = item;
                    });
                    newArray = Object.values(uniqueAttachmentIds);
                    _jobItem = __spreadArray([], jobItemList, true);
                    urlconfirmation = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
                        images: newArray,
                        isOpenCameraandGallery: !item.isOpenCameraandGallery,
                        SystemName: filterSystemName
                    }) : item; });
                    setJobItemList(urlconfirmation);
                    onChange(urlconfirmation, groupItem);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleViewAllClick = function (items) {
        var _jobItem = __spreadArray([], jobItemList, true);
        var showAllImages = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
            isShowImage: !item.isShowImage
        }) : item; });
        setJobItemList(showAllImages);
        onChange(showAllImages, groupItem);
    };
    var handleOpenGalleryClick = function (items) {
        var _jobItem = __spreadArray([], jobItemList, true);
        var galleryAndCamera = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
            isOpenCameraandGallery: !item.isOpenCameraandGallery
        }) : item; });
        setJobItemList(galleryAndCamera);
        onChange(galleryAndCamera, groupItem);
    };
    var onClickRemovePhotoIcon = function (items, index) { return __awaiter(void 0, void 0, void 0, function () {
        var _items$images$index, _DeleteAttchementResp, _DeleteAttchementResp2, _jobItem, request, DeleteAttchementResponse, finalList_1, finalDeleteItem, _jobItem, finalList_2, finalDeleteItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(items.images[index].isAlreadyUploaded && !((_items$images$index = items.images[index]) !== null && _items$images$index !== void 0 && _items$images$index.isNewImageUploaded))) return [3 /*break*/, 4];
                    _jobItem = __spreadArray([], jobItemList, true);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        "SystemName": "Complaint",
                        ParentId: items.ComplaintId,
                        AttachmentId: items.images[index].attachmentId,
                        PreJobCardDocumentId: id !== null && id !== void 0 ? id : vehicleInspectionId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: translateToJobDeleteAttachement,
                            request: request
                        }))];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp === void 0 || (_DeleteAttchementResp = _DeleteAttchementResp.value) === null || _DeleteAttchementResp === void 0 ? void 0 : _DeleteAttchementResp.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp2 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp2 !== void 0 && (_DeleteAttchementResp2 = _DeleteAttchementResp2.value) !== null && _DeleteAttchementResp2 !== void 0 && _DeleteAttchementResp2.success) {
                        finalList_1 = __spreadArray([], items.images, true);
                        finalList_1 === null || finalList_1 === void 0 || finalList_1.splice(index, 1);
                        finalDeleteItem = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
                            images: finalList_1
                        }) : item; });
                        setJobItemList(finalDeleteItem);
                        onChange(finalDeleteItem, groupItem);
                    }
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    return [3 /*break*/, 5];
                case 4:
                    _jobItem = __spreadArray([], jobItemList, true);
                    finalList_2 = __spreadArray([], items.images, true);
                    finalList_2 === null || finalList_2 === void 0 || finalList_2.splice(index, 1);
                    finalDeleteItem = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
                        images: finalList_2
                    }) : item; });
                    setJobItemList(finalDeleteItem);
                    onChange(finalDeleteItem, groupItem);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onDeleteClick = function (items) {
        var _jobItem = __spreadArray([], jobItemList, true);
        var urlconfirmation = _jobItem.map(function (item) { return item.ComplaintId === items.ComplaintId ? _objectSpread(_objectSpread({}, item), {}, {
            audioUrl: "",
            audioDuration: "",
            audioAttachmentId: "",
            isAudioDelete: true
        }) : item; });
        setJobItemList(urlconfirmation);
        onChange(urlconfirmation, groupItem);
        if (items.isAudioAlreadyUploaded && !items.isNewAudioUploaded) {
            var request = {
                SystemName: "PreJobCardDocument",
                ParentId: items.ComplaintId,
                AttachmentId: items === null || items === void 0 ? void 0 : items.audioAttachmentId,
                PreJobCardDocumentId: id !== null && id !== void 0 ? id : vehicleInspectionId
            };
            dispatch(getListAPI({
                key: "",
                url: translateToJobDeleteAttachement,
                request: request
            }));
        }
    };
    var handleClose = function () {
        setImageURL("");
        setISDrawerOpen(false);
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    return /*#__PURE__*/ React.createElement(Box, {
        borderRadius: '8px',
        marginTop: 0
    }, /*#__PURE__*/ React.createElement(FormControl, {
        sx: {
            width: '100%',
            margin: "0px"
        },
        component: "fieldset",
        variant: "standard"
    }, /*#__PURE__*/ React.createElement(FormGroup, {
        sx: {
            padding: '12px',
            margin: 0
        }
    }, (jobItemList === null || jobItemList === void 0 ? void 0 : jobItemList.length) > 0 ? jobItemList === null || jobItemList === void 0 ? void 0 : jobItemList.map(function (item, index) {
        var existInSearch = searchedItems === null || searchedItems === void 0 ? void 0 : searchedItems.find(function (searchItem) { return searchItem.ComplaintId === item.ComplaintId; });
        if (!existInSearch && searchValue.length >= 3) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
        if (item.ComplaintName) {
            var _item$Comments, _item$images, _item$isOpenCameraand, _item$images2, _item$audioDuration;
            return /*#__PURE__*/ React.createElement(Grid, {
                padding: 0,
                key: index + 1
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                padding: 0,
                margin: 0,
                spacing: 1.3
            }, /*#__PURE__*/ React.createElement(FormControlLabel, {
                key: "mode-checkbox-".concat(index),
                control: /*#__PURE__*/ React.createElement(Checkbox, {
                    id: "transanslateToJobCheckBox" + index,
                    checked: item.isCheckBoxClicked || false,
                    onChange: function (e) { return handleChange(e, item); },
                    disabled: isDisabled
                }),
                label: "",
                sx: {
                    marginLeft: 0,
                    marginRight: 0,
                    minHeight: '50px',
                    '& .MuiButtonBase-root': {
                        padding: 0
                    }
                }
            }), /*#__PURE__*/ React.createElement(Typography, {
                id: "JobName",
                sx: {
                    fontSize: 'base',
                    fontWeight: 'medium',
                    color: 'text.primary'
                },
                alignSelf: "center"
            }, item.ComplaintName)), item.isCheckBoxClicked && /*#__PURE__*/ React.createElement(Grid, {
                xs: 12,
                justifyContent: "center"
            }, /*#__PURE__*/ React.createElement("div", {
                style: {
                    position: 'relative',
                    paddingBottom: 10
                }
            }, /*#__PURE__*/ React.createElement(TextField, {
                inputProps: {
                    maxLength: FreeTextMaxLength
                },
                id: "multiline-input-".concat(index),
                placeholder: t('ENTER_SA_COMMENT_PLACEHOLDER'),
                multiline: true,
                rows: 4,
                fullWidth: true,
                value: item === null || item === void 0 || (_item$Comments = item.Comments) === null || _item$Comments === void 0 ? void 0 : _item$Comments.trimStart(),
                InputProps: {
                    style: {
                        borderRadius: '8px 8px 8px 8px',
                        paddingBottom: 30
                    }
                },
                style: {
                    margin: 0
                },
                onChange: function (e) { return handleTextInputChange(e, item); }
            }), /*#__PURE__*/ React.createElement("div", {
                style: {
                    position: 'absolute',
                    left: "8px",
                    bottom: 15
                }
            }, /*#__PURE__*/ React.createElement(IconButton, {
                disabled: isDisabled || !item.Comments
            }, isDisabled || !item.Comments ? /*#__PURE__*/ React.createElement(GalleryIcon, {
                id: "addPhoto",
                sx: {
                    color: systemColor.disabled
                }
            }) : /*#__PURE__*/ React.createElement(GalleryIcon, {
                id: "addPhoto",
                sx: {
                    color: systemColor.primary
                },
                onClick: function () { return handleOpenGalleryClick(item); }
            })), /*#__PURE__*/ React.createElement(ImageCapture, {
                downloadedImages: (_item$images = item === null || item === void 0 ? void 0 : item.images) !== null && _item$images !== void 0 ? _item$images : [],
                isOpen: (_item$isOpenCameraand = item === null || item === void 0 ? void 0 : item.isOpenCameraandGallery) !== null && _item$isOpenCameraand !== void 0 ? _item$isOpenCameraand : false,
                handleClose: function () { return handleOpenGalleryClick(item); },
                handleImageList: function (list, removedImageList) { return handleImageList(list, removedImageList, item); }
            })), /*#__PURE__*/ React.createElement("div", {
                style: {
                    position: 'absolute',
                    left: "45px",
                    bottom: 15
                }
            }, /*#__PURE__*/ React.createElement(IconButton, {
                id: "addAudio",
                disabled: isDisabled || !item.Comments
            }, /*#__PURE__*/ React.createElement(AudioComponent, {
                isDisablebtn: isDisabled || !item.Comments,
                handleurl: function (value, duration, convertedBlob) { return handleAudioUrl(value, duration, convertedBlob, item); }
            })))), item.images && /*#__PURE__*/ React.createElement(MuiStack, {
                paddingTop: 1
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'row',
                alignItems: "center",
                gap: 2
            }, item === null || item === void 0 || (_item$images2 = item.images) === null || _item$images2 === void 0 ? void 0 : _item$images2.slice(0, 3).map(function (image, photoIndex) {
                return /*#__PURE__*/ React.createElement(Box, {
                    key: photoIndex
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "1st",
                    style: {
                        position: 'relative',
                        display: 'inline-block'
                    }
                }, 
                /*#__PURE__*/
                // image.isAlreadyUploaded &&
                React.createElement(GridCloseIcon, {
                    id: "image-delete",
                    onClick: function () { return onClickRemovePhotoIcon(item, photoIndex); },
                    sx: {
                        position: 'absolute',
                        zIndex: 1,
                        right: 10,
                        top: 8,
                        backgroundColor: "white",
                        height: '15px',
                        width: '15px',
                        borderRadius: 50
                    }
                }), /*#__PURE__*/ React.createElement("img", {
                    id: "image",
                    src: image === null || image === void 0 ? void 0 : image.blobUrl,
                    alt: "Image ".concat(index + 1),
                    style: {
                        width: '82px',
                        height: '82px',
                        borderRadius: '8px',
                        position: 'relative'
                    },
                    onClick: function () { return handleClickImage(image === null || image === void 0 ? void 0 : image.blobUrl); }
                }), (item === null || item === void 0 ? void 0 : item.images.length) > 3 && photoIndex === 2 && !item.isShowImage && /*#__PURE__*/ React.createElement(Typography, {
                    variant: "body2",
                    sx: {
                        position: 'absolute',
                        top: '40px',
                        left: '20%',
                        color: '#FFFFFF',
                        cursor: 'pointer'
                    },
                    onClick: function () { return handleViewAllClick(item); }
                }, t("View All"))));
            })))), /*#__PURE__*/ React.createElement(ViewAllImagePopUp, {
                isOpen: item.isShowImage,
                onClosed: function () { return handleViewAllClick(item); },
                images: item === null || item === void 0 ? void 0 : item.images
            }), item.audioUrl &&
                /*#__PURE__*/
                // <Grid item padding={"9px"} width={"100%"}>
                React.createElement(MuiStack, {
                    width: '100%',
                    alignItems: 'center',
                    border: "1px solid ".concat(systemColor.grey),
                    borderRadius: '4px'
                }, /*#__PURE__*/ React.createElement(AudioPlayer, {
                    src: item === null || item === void 0 ? void 0 : item.audioUrl,
                    isSlider: true,
                    audioDuration: (_item$audioDuration = item === null || item === void 0 ? void 0 : item.audioDuration) !== null && _item$audioDuration !== void 0 ? _item$audioDuration : 0
                }), /*#__PURE__*/ React.createElement("img", {
                    id: "audio-delete",
                    src: DeleteButtonNewIcon,
                    alt: "gallery-disable",
                    style: {
                        width: '36px',
                        height: '36px',
                        marginLeft: '10px'
                    },
                    onClick: function () { return onDeleteClick(item); }
                }))
            // </Grid>
            );
        }
        else {
            return /*#__PURE__*/ React.createElement(MuiStack, {
                padding: 1
            }, /*#__PURE__*/ React.createElement(Typography, null, t("No data found")));
        }
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isSkeletonVisible && /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1
    }, /*#__PURE__*/ React.createElement(Typography, null, t("No data found")))), /*#__PURE__*/ React.createElement(React.Fragment, null, isSkeletonVisible && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '50px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    }))));
};
